function hasEffectiveGlobalPromotionForPageDiscount(input) {
    const mode = input.globalPromotionMode;
    if (!mode || mode === 'DISABLED')
        return false;
    if (mode === 'AUTO_SYNC')
        return input.hasBestDiscount;
    if (mode === 'MANUAL')
        return input.hasGlobalPromotion;
    return input.hasGlobalPromotion || input.hasBestDiscount;
}
/**
 * Effective Brand Center promotion that locks the page-level discount UI.
 * Matches LandingPageSettings: when this returns non-null, page discount
 * fields are read-only and must be edited in Brand Center instead.
 */
export function effectiveGlobalPromotionForPageDiscount(input) {
    var _a, _b, _c, _d;
    if (!hasEffectiveGlobalPromotionForPageDiscount({
        globalPromotionMode: input.globalPromotionMode,
        hasGlobalPromotion: input.globalPromotion != null,
        hasBestDiscount: input.bestDiscount != null,
    })) {
        return null;
    }
    const mode = input.globalPromotionMode;
    if (mode === 'AUTO_SYNC')
        return (_a = input.bestDiscount) !== null && _a !== void 0 ? _a : null;
    if (mode === 'MANUAL')
        return (_b = input.globalPromotion) !== null && _b !== void 0 ? _b : null;
    return (_d = (_c = input.globalPromotion) !== null && _c !== void 0 ? _c : input.bestDiscount) !== null && _d !== void 0 ? _d : null;
}
/**
 * A storefront's own discount code beats the brand promotion only when the
 * brand has opted into STOREFRONT precedence. Banner text alone never
 * overrides, so banner, price and checkout code always come from one source.
 */
export function storefrontPromotionTakesPrecedence(input) {
    var _a;
    return (input.promotionPrecedence === 'STOREFRONT' &&
        !!((_a = input.pageDiscountCode) === null || _a === void 0 ? void 0 : _a.trim()));
}
/**
 * Under STOREFRONT precedence the page fields stay editable even while a
 * brand promotion runs, since entering a code is how a storefront overrides it.
 */
export function isPageDiscountEditable(input) {
    if (input.promotionPrecedence === 'STOREFRONT')
        return true;
    return effectiveGlobalPromotionForPageDiscount(input) == null;
}
/** Presence-only variant for backends that avoid hydrating full promotions. */
export function isPageDiscountEditableByPresence(input) {
    if (input.promotionPrecedence === 'STOREFRONT')
        return true;
    return !hasEffectiveGlobalPromotionForPageDiscount(input);
}
